module.exports = __webpack_public_path__ + "static/media/success_prize.3c7a840f.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/success_prize.png
// module id = 1462
// module chunks = 0